export default __webpack_public_path__ + "static/media/signOutIcon.d5c71246.svg";